/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { JiraIssuesConfigModalWithWrappers } from './JiraIssuesConfigModalWithWrappers';

export const JIRA_LIST_OF_LINKS_DATASOURCE_ID = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

export default JiraIssuesConfigModalWithWrappers;

/**
 * @deprecated Use `import { JiraIssuesConfigModalWithWrappers } from '@atlaskit/link-datasource/jira-issues-config-modal-with-wrappers'` instead.
 */
export { JiraIssuesConfigModalWithWrappers } from './JiraIssuesConfigModalWithWrappers';
/**
 * @deprecated Use `import { JiraIssuesConfigModalWithWrappers } from '@atlaskit/link-datasource/jira-issues-config-modal-with-wrappers'` instead.
 */
export { JiraIssuesConfigModalWithWrappers as JiraIssuesConfigModal } from './JiraIssuesConfigModalWithWrappers';
